import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const STATS = [
  { value: "26+", label: "Years of craft" },
  { value: "8,000+", label: "Events dressed" },
  { value: "1", label: "Family-run shop" },
];

export default function Heritage() {
  return (
    <section data-testid="heritage-section" className="bg-forest py-28 text-cream lg:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
          className="relative lg:col-span-5"
        >
          <div className="absolute -left-4 -top-4 h-full w-full border border-marigold/50" />
          <img
            src="https://images.unsplash.com/photo-1593343352582-20b62e004a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHx2aW50YWdlJTIwZmxvd2VyJTIwc2hvcCUyMGV4dGVyaW9yfGVufDB8fHx8MTc4ODA3NDA2Nnww&ixlib=rb-4.1.0&q=85"
            alt="The Utsav Flowers shopfront"
            data-testid="heritage-image"
            className="relative aspect-[4/5] w-full object-cover"
            loading="lazy"
          />
        </motion.div>

        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-cream/50"
          >
            Since 1999
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="font-serif text-4xl font-medium leading-tight tracking-tight md:text-6xl"
          >
            Twenty-six years of mornings
            <br />
            <span className="italic text-marigold">at the flower market.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
            className="mt-8 max-w-xl text-base leading-relaxed text-cream/70"
          >
            What began as a single counter of marigolds and tuberoses is today
            Dibrugarh's most trusted flower house. Three generations of regulars
            buy their first roses here, come back for their wedding décor, and
            bring their children for theirs. That is the Utsav way — flowers,
            with memory attached.
          </motion.p>

          <div className="mt-12 grid grid-cols-3 gap-8 border-t border-cream/15 pt-10">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 + i * 0.1, ease: EASE }}
                data-testid={`heritage-stat-${i}`}
              >
                <p className="font-serif text-4xl italic text-marigold md:text-5xl">{s.value}</p>
                <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/50">
                  {s.label}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
